import React, {Component} from 'react'
import PropTypes from "prop-types";
import MyTable from "../TableComponents/Table";
import SvGraphics from "../../assets/SvGraphics";
import doctorApi from "../../services/ApiServices/doctorApi";
import ProductTable from "../TableComponents/ProductTable";


class TreatmentProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
  /*      if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }*/
    }

    getColumns = (t) => {
        let currentEntry= this.props.current
        let product =currentEntry?currentEntry.Treatment_plan_selected_product:""
        return [
            // {accessor: 'Product_ID', Header: "ID", resizable: false,display:'none'},
            {accessor: 'Brand', Header: "Brand", resizable: false},
            {accessor: 'Product_name', Header: "Product Name", resizable: false},
            {accessor: 'Category', Header: "Code", resizable: false},
            {accessor: 'Rating', Header: "Rating", resizable: false},
            {accessor: 'Select', Header: "", resizable: false,Cell: ({ original }) => {
                    return (
                        product === original['Product_name'] ?
                            <div className={'selected-prod'}
                                 onClick={()=>this.onSelectionChange(original['Product_name'],original['Product_ID'])}>{t('patient_boarding.unselect')}</div>
/*
                                <label className={'select-product-label'} onClick={()=>this.onSelectionChange(original['Product_name'])}>{t('patient_boarding.unselect')}</label>
*/
                            : <div className={'unselected-prod'}
                                onClick={()=>this.onSelectionChange(original['Product_name'],original['Product_ID'])}>{t('patient_boarding.select')}</div>


/*
                    <label className={'select-product-label'} onClick={()=>this.onSelectionChange(original['Product_name'])}>{t('patient_boarding.select')}</label>
*/
                    )
                }},
        ]
    }

    editTreatmentPlan = (func,value,index) => {
        this.props.editTreatmentPlan(func,value,index)
    }

    async componentDidMount() {

    }

    onSelectionChange(selected,ProdID){
        let currentEntry= this.props.current
        if(currentEntry.Treatment_plan_selected_product===selected){
            this.editTreatmentPlan("Treatment_plan_selected_product", "",this.props.index)
            this.editTreatmentPlan("Product_ID", "",this.props.index)
        }else{
            this.editTreatmentPlan("Treatment_plan_selected_product", selected,this.props.index)
            this.editTreatmentPlan("Product_ID", ProdID,this.props.index)
            this.props.changeView(5)
        }


    }
    render() {
        let {entry} = this.state
        let {t}=this.props

        let columns = this.getColumns(t)
        let products =this.props.productsList
        let displayProducts=[]
        let currentEntry= this.props.current

        let treatmentIntake = currentEntry.TreatmentIntakeMethod?currentEntry.TreatmentIntakeMethod:""
        let treatmentCat = currentEntry.TreatmentCategory?currentEntry.TreatmentCategory:""
        let treatmentVar = currentEntry.TreatmentVariety?currentEntry.TreatmentVariety:""
        for(let i=0;i<products.length;i++){

            let checkVariety = treatmentVar==="Select All" ||
                (treatmentVar=== "Indica"&& products[i].Indica_Sativa_Hyprid==="Indica")
                ||(treatmentVar=== "Sativa" && products[i].Indica_Sativa_Hyprid==="Sativa")
                ||(treatmentVar=== "Blend"&& products[i].Indica_Sativa_Hyprid==="Blend")

            if
            (treatmentCat === products[i].Category
                && checkVariety
            && ((treatmentIntake.includes("Flower") && products[i].Strain===("Flower"))||
                    treatmentIntake.includes("Oil") && products[i].Strain===("Oil"))){
                displayProducts.push(products[i])
            }
        }

        return (
            <div style={{display:this.props.view===5?'block':'none'}}>
                <div className={"treatment-plan-boxes-title"}> {t('patient_boarding.Product')}</div>

                <ProductTable
                    data={displayProducts}
                    initialData={displayProducts}
                    columns={columns}
                    defaultPageSize={8}
                    hasShowInfo={false}
                />

            </div>

        )
    }
}

TreatmentProduct.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TreatmentProduct;
